import{a as t}from"./chunk-RAAYCPUM.js";function a(...n){return t(i,n)}var i=n=>`${n[0]?.toLowerCase()??""}${n.slice(1)}`;export{a};
